import { render, staticRenderFns } from "./CollapsePaginationArrow.vue?vue&type=template&id=214cad25&"
import script from "./CollapsePaginationArrow.vue?vue&type=script&lang=js&"
export * from "./CollapsePaginationArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports